import { render } from "./TheDuAnDauTu.vue?vue&type=template&id=4a9f6e82"
import script from "./TheDuAnDauTu.vue?vue&type=script&lang=js"
export * from "./TheDuAnDauTu.vue?vue&type=script&lang=js"

import "./TheDuAnDauTu.vue?vue&type=style&index=0&id=4a9f6e82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__